import { useCallback, useEffect, useState } from 'react';

/**
 * Co leží v teple (hotové rozvozy bez dávky) a co se ještě vaří.
 *
 * Hotová objednávka má naskočit hned: kuchyň při každé změně vysílá
 * StavKuchyneZmenen (kanál posílá server), pokladna nové a změněné objednávky
 * na objednavky.live. Víc změn naráz (dokončení várky) se slije do jednoho
 * dotazu. 15 s interval je jen pojistka pro výpadek WebSocketu a po návratu
 * z pozadí se načte znovu.
 *
 * @return {{ data: ?{na_smene, kanal, hotove, vari_se, limit}, err: ?string, nacti: () => Promise<void> }}
 */
export default function useVTeple() {
    const [data, setData] = useState(null);
    const [err, setErr] = useState(null);

    const nacti = useCallback(async () => {
        try {
            const r = await fetch('/api/rozvoz/v-teple', { credentials: 'same-origin' });
            if (!r.ok) throw new Error(`HTTP ${r.status}`);
            setData(await r.json());
            setErr(null);
        } catch (e) {
            setErr(e?.message || String(e));
        }
    }, []);

    useEffect(() => {
        nacti();
        const t = setInterval(nacti, 15000);
        window.addEventListener('app-resumed', nacti);
        return () => { clearInterval(t); window.removeEventListener('app-resumed', nacti); };
    }, [nacti]);

    const kanalKuchyne = data?.kanal;
    useEffect(() => {
        if (!kanalKuchyne || !window.Echo) return undefined;
        let odklad;
        const brzy = () => { clearTimeout(odklad); odklad = setTimeout(nacti, 300); };
        const kuchyne = window.Echo.private(kanalKuchyne);
        const objednavky = window.Echo.private('objednavky.live');
        kuchyne.listen('.StavKuchyneZmenen', brzy);
        objednavky.listen('.ObjednavkaAktualizovana', brzy).listen('.NovaObjednavka', brzy);
        // stopListening, ne leave — kanály sdílí i jiné části OS
        return () => {
            clearTimeout(odklad);
            kuchyne.stopListening('.StavKuchyneZmenen', brzy);
            objednavky.stopListening('.ObjednavkaAktualizovana', brzy).stopListening('.NovaObjednavka', brzy);
        };
    }, [kanalKuchyne, nacti]);

    return { data, err, nacti };
}
